/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3dvcmxkLXJhbmtpbmctc3RhdGlzdGljcy9wcml6ZS1mb3ItcHJlY2lzaW9uL2NvbXBvbmVudHMvcHJpY2UtZm9yLXByZWNpc2lvbi1kZXRhaWxzL3ByaWNlLWZvci1wcmVjaXNpb24tZGV0YWlscy5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
